// src/library/control/agent-listed.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@aws-amplify/ui-react";
import type { Agent } from "@heartcheck/shared";

export type ConfigurationAgentItemProps = {
  agent: Agent;
};

/**
 * Sidebar list item for a single Agent in the Configuration sidebar.
 * Navigates to /configuration/agent/:id when clicked.
 */
export const ConfigurationAgentItem: React.FC<ConfigurationAgentItemProps> = ({
  agent,
}) => {
  const nav = useNavigate();

  const onClick = () => {
    nav(`/configuration/agent/${agent.id}`);
  };

  return (
    <Button
      onClick={onClick}
      isFullWidth
      variation="link"
      justifyContent="start"
      className="text-left text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 px-4 py-2 rounded-md"
    >
      {agent.name}
    </Button>
  );
};

// Optional: default export for flexibility if you ever want to
// `import ConfigurationAgentItem from "../library/control/agent-listed";`
export default ConfigurationAgentItem;
